import { Builder, withChildren } from '@builder.io/react';

import Section from '../../elements/section/index';

const SectionWithBuilderChildren = withChildren(Section);

Builder.registerComponent(SectionWithBuilderChildren, {
  name: 'SectionFeaturesSideBySide',
  inputs: [
    {
      name: 'id',
      type: 'string'
    },
    {
      name: 'container',
      type: 'boolean'
    },
    {
      name: 'bg',
      type: 'string',
      defaultValue: 'bg-transparent',
      enum: [
        'bg-transparent',
        'bg-neutral-950',
        'bg-neutral-900',
        'bg-neutral-100',
        'bg-neutral-800'
      ]
    },
    {
      name: 'relative',
      type: 'boolean'
    },
    {
      name: 'paddingTop',
      type: 'boolean'
    },
    {
      name: 'paddingBottom',
      type: 'boolean'
    },
    {
      name: 'overflowHidden',
      type: 'boolean'
    }
  ],
  defaultChildren: [
    {
      component: {
        name: 'SectionTitle',
        options: {
          overtitle: 'Duis Mollis',
          title: 'Sed posuere consectetur estat lobortis posuere',
          subtitle:
            'Sed posuere consectetur est at lobortis. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.Sed posuere consectetur est at lobortis. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio.'
        }
      }
    },
    {
      component: {
        name: 'FeaturesSideBySide',
        options: {
          features: [
            {
              overtitle: 'Evaluate',
              title: 'Test, Validate & Debug Models',
              description:
                'Upload predictions to Nucleus via API. Track model performance, compare model runs, sort failure examples by metrics of interest, and build model unit tests out of curated dataset slices to catch regressions in key scenarios.',
              images: [
                {
                  src: 'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2F6baff06522784be79958acb6d072c096',
                  width: 528,
                  height: 528,
                  alt: 'audio-collection'
                }
              ]
            }
          ]
        }
      }
    }
  ]
});
